/** Injects dangerous HTML onto the page, such as iFrame embeds.
 * @param {String} input - The HTML of the content that should be rendered.
 * @returns {String} - JSX representation of the content.
 */
export const htmlDecode = (input) => {
  const e = document.createElement('div');
  e.innerHTML = input;
  return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
};



// WEBPACK FOOTER //
// ./src/util.js